<template>
    <div>
        <div class="sub__maxWidth">
            <div class="title">
                <span class="sub-style">성별</span>을<br/>
                선택해주세요.
            </div>

            <div class="avatar">
                <button
                    class="gender"
                    @click="selectMale"
                    tabindex="1"
                    role="button"
                >
                    <template v-if="userInfo.gender === '1'">
                        <img
                            src="@/assets/images/avatar-gender-m-s.png"
                            class="gender-img"
                            alt="선택된 남자"
                        />
                        <br/>
                        <span class="selected-text">남자</span>
                    </template>
                    <template v-else>
                        <img
                            src="@/assets/images/avatar-gender-m-n.png"
                            class="gender-img"
                            alt="선택되지 않은 남자"
                        />
                        <br/>
                        남자
                    </template>
                </button>
                <button
                    class="gender"
                    @click="selectFemale"
                    tabindex="2"
                    role="button"
                >
                    <template v-if="userInfo.gender === '2'">
                        <img
                            src="@/assets/images/avatar-gender-w-s.png"
                            class="gender-img"
                            alt="선택된 여자"
                        />
                        <br/>
                        <span class="selected-text">여자</span>
                    </template>
                    <template v-else>
                        <img
                            src="@/assets/images/avatar-gender-w-n.png"
                            class="gender-img"
                            alt="선택되지 않은 여자"
                        />
                        <br/>
                        여자
                    </template>
                </button>
            </div>
        </div>
        
        <div class="btn-wrapper">
            <button class="cancel_btn" @click="previous" tabindex="2">＜ 이전</button>
            <button
                :class="this.enableButton ? 'start_enable_btn' : 'start_disable_btn'"
                :disabled="!this.enableButton"
                @click="next"
            >
                다음 ＞
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";

export default {
	data () {
	    return {
            userInfo: {
                gender: "0"
            },
            enableButton: false
        }
    },

	methods: {
		...mapActions("user", ["setUser"]),
		...mapActions("survey", ["setStep"]),
		//이전
		previous() {
			this.setStep(1)
			this.$router.push("/checkup/step1");
		},
		//다음
		next() {
			const params = {
				step: 2,
				gender: this.userInfo.gender
			}
			this.setUser(params)
			this.setStep(3)
			this.$router.push("/checkup/step3")
		},
		//버튼활성화
		buttonChange() {
			this.enableButton = (this.userInfo.gender == "1" || this.userInfo.gender == "2");
		},
		selectMale() {
			this.userInfo.gender = "1";
		},
		selectFemale() {
			this.userInfo.gender = "2";
		}
	},
	watch: {
		"userInfo.gender": function() {
			this.buttonChange();
		}
	},
	computed: {
		...mapGetters("user", {
			getUser: "getUser"
		})
	},
	mounted() {
        this.setStep(2)
        if (this.getUser.gender !== null) {
            this.userInfo.gender = this.getUser.gender
        }
	}
};
</script>

<style lang="scss" scoped>
    .title {
        min-height: 25vh;
    }
    .gender-wrapper {
        text-align: center;
        margin-bottom: 10vh;
    }
    .gender {
        display: inline-block;
        color: #809bb2;
        font-size: 18px;
        padding: 0px 3vw 5vw 0px;
    }
    .gender-img {
        width: 30vw;
        max-width: 114px;
    }
    .selected-text {
        font-weight: bold;
        color: #3f6fff;
    }

    .btn-wrapper {
        width: 100%;
        max-width: 500px;
        margin: auto auto 20px auto;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
    }

    .btn-wrapper {
        width: 100%;
        max-width: 500px;
        margin: auto auto 20px auto;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
    }

    .cancel_btn {
		display: inline-block;
		width: 33%;
		height: 44px;
		border-radius: 22px;
		margin-right: 5vw;
		background-color: #eaeaea;
        font-family: NanumSquare, sans-serif;
		border: 0;
		outline: none;
	}

    .start_enable_btn {
		display: inline-block;
		width: 62%;
		height: 44px;
		border-radius: 22px;
		box-shadow: 0 8px 20px -4px rgba(63, 111, 255, 0.5);
		background-color: #3f6fff;
        font-family: NanumSquare, sans-serif;
        color: white;
		border: 0;
		outline: none;
	}

	.start_disable_btn {
		display: inline-block;
		width: 62%;
		height: 44px;
		border-radius: 22px;
		box-shadow: 0 3px 10px -4px rgba(63, 111, 255, 0.5);
		background-color: #a7bdff;
        font-family: NanumSquare, sans-serif;
        color: white;
		border: 0;
    }
</style>
